import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Appqr from '../../components/Appqr';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./WineTastingPage.css";

const images = [
  "/assests/images/pairing-1.jpg",
  "/assests/images/pairing-2.jpg",
  "/assests/images/pairing-1.jpg",
];

const WineTastingPage = () => {
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    centerMode: true,
    centerPadding: "13%",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "0",
        },
      },
    ],
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    document.title = `Wine tasting Page | Your Friend My Friend`;
    document.getElementById("bodywrap").className = "speedys";
  }, []);

  return (
    <>
      <Header />

      <div className="hello-worldss d-flex justify-content-center align-items-center">
        {/* Desktop Image */}
        <img
          src={process.env.REACT_APP_BASE_URL + "assests/images/tasty-d.jpg"}
          alt="QR Code"
          className="img-fluid d-none d-md-block"
        />

        {/* Mobile Image */}
        <img
          src={process.env.REACT_APP_BASE_URL + "assests/images/tasty-m.jpg"}
          alt="QR Code"
          className="img-fluid d-block d-md-none"
        />
      </div>

      <div className="container-fluid ireland">
        <div className="row g-4">
          <div className="col-md-6 ire-left">
            <p>WINE TASTING</p>
            <h2>Sip, Socialise & Connect</h2>
          </div>

          <div className="col-md-6 ire-right">
            <p>
              Our Singles Wine Tastings are the perfect blend of great wine,
              good conversation, and real connections. Whether you're a wine
              enthusiast or just enjoy a casual drink, these events offer a
              relaxed and enjoyable way to meet like-minded singles while
              exploring a curated selection of wines.
            </p>
            <div className="arrive">
              <Link
                to="/upcoming-events"
                className="btn bros-bu text-decoration-none"
              >
                BROWSE EVENTS
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid expand new-expa">
        <div className="row align-items-strech d-flex">
          {/* Left Side Content */}
          <div className="col-md-6 d-flex flex-column justify-content-between">
            <div className="tired">
              <h2>HOW IT WORKS</h2>
              <h4>What to expect </h4>
              <p>
                No swiping, no awkward introductions—just good wine, good vibes,
                and real connections.
              </p>
            </div>
            <div className="tired-2">
              <Link
                to="/upcoming-events"
                className="brow-bu text-decoration-none d-none d-md-inline-block"
              >
                BROWSE EVENTS
              </Link>
              <Link
                to="/contact"
                className="brow-bu text-decoration-none d-block d-md-none text-center mb-4"
              >
                Get in touch
              </Link>
            </div>
          </div>

          {/* Right Side Features */}
          <div className="col-md-6 d-flex flex-column">
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src={
                  process.env.REACT_APP_BASE_URL + "assests/images/ano-1.png"
                }
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>A Guided Wine Experience</h5>
                <p>
                  Enjoy a handpicked selection of wines with expert insights
                  along the way.
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src={
                  process.env.REACT_APP_BASE_URL + "assests/images/pect-4.png"
                }
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>Easy, Relaxed Mingling </h5>
                <p>
                  No pressure, just great conversation over a shared love of
                  wine.
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src="/assests/images/venu-3.png"
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>Perfectly Paired Company</h5>
                <p>
                  A balanced mix of men and women, all looking to meet new
                  people
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat locat">
              <img
                src={
                  process.env.REACT_APP_BASE_URL + "assests/images/venu-4.png"
                }
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>A Social Setting That Flows Naturally</h5>
                <p>
                  No formal structure, just a welcoming atmosphere where
                  connections happen organically.
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat locats">
              <img
                src={
                  process.env.REACT_APP_BASE_URL + "assests/images/ano-2.png"
                }
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>Stay for Another Glass </h5>
                <p>
                  Once the tasting ends, the night continues—stick around, keep
                  chatting, and enjoy the company.{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid real-connection new-real sparks">
        <div className="row justify-content-between">
          <div className="col-md-5 d-flex flex-column justify-content-between">
            <div className="slidees ols">
              <h6>YFMF</h6>
              <h2>A perfect pairing of great wine and good conversations.</h2>
            </div>
            <div className="d-none d-md-flex justify-content-start">
              <button
                className="btn"
                onClick={() => sliderRef.current.slickPrev()}
              >
                <div className="arrow-container">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-left.png"
                    }
                    className="img-fluid arrow-image arrow-image-1"
                    alt="Previous"
                  />
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-left-hover.png"
                    }
                    className="img-fluid arrow-image arrow-image-2"
                    alt="Previous Hover"
                  />
                </div>
              </button>
              <button
                className="btn"
                onClick={() => sliderRef.current.slickNext()}
              >
                <div className="arrow-container">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-right.png"
                    }
                    className="img-fluid arrow-image arrow-image-1"
                    alt="Next"
                  />
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-right-hover.png"
                    }
                    className="img-fluid arrow-image arrow-image-2"
                    alt="Next Hover"
                  />
                </div>
              </button>
            </div>
          </div>

          <div className="col-md-1"></div>

          <div className="col-md-6 pe-md-0">
            <div>
              <Slider ref={sliderRef} {...settings}>
                {images.map((img, i) => (
                  <div
                    key={i}
                    className={`custom-slide ${
                      i === images.length - 1 ? "last-slide" : ""
                    }`}
                  >
                    <img
                      src={process.env.REACT_APP_BASE_URL + img}
                      className="img-fluid respo"
                      alt={`Slide ${i}`}
                      style={{
                        width: "100%",
                        height: "460px",
                        borderRadius: 24,
                        objectFit: "cover",
                      }}
                      onError={(e) => (e.target.style.display = "none")}
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </div>

          <div className="col-12 d-flex d-md-none justify-content-between mt-3 p-0">
            <button
              className="btn"
              onClick={() => sliderRef.current.slickPrev()}
            >
              <div className="arrow-container">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-left.png"
                  }
                  className="img-fluid arrow-image arrow-image-1"
                  alt="Previous"
                />
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-left-hover.png"
                  }
                  className="img-fluid arrow-image arrow-image-2"
                  alt="Previous Hover"
                />
              </div>
            </button>
            <button
              className="btn"
              onClick={() => sliderRef.current.slickNext()}
            >
              <div className="arrow-container">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-right.png"
                  }
                  className="img-fluid arrow-image arrow-image-1"
                  alt="Next"
                />
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-right-hover.png"
                  }
                  className="img-fluid arrow-image arrow-image-2"
                  alt="Next Hover"
                />
              </div>
            </button>
          </div>
        </div>
      </div>

      <div className="accors accordi good">
        <div className="row">
          <div className="col-md-6">
            <h2>FAQ</h2>
            <h3>Good to know</h3>
          </div>
          <div className="col-md-6">
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  What is a Singles Wine Tasting event?
                </Accordion.Header>
                <Accordion.Body>
                  Your Friend, My Friend’s Singles Wine Tasting is a social
                  evening designed for single people to connect over great wine,
                  good conversation, and a shared experience. It’s not your
                  typical wine class, it’s a relaxed, hosted event where
                  everyone attending is single and open to meeting new people in
                  person.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>How does the event work?</Accordion.Header>
                <Accordion.Body>
                  Guests are welcomed with a drink before being guided through a
                  curated tasting experience by a wine expert or sommeli er.
                  Throughout the night, you'll move around, sample several
                  wines, and meet new people in a casual, no - pressure setting.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  Do I need to know a lot about wine to attend?
                </Accordion.Header>
                <Accordion.Body>
                  Not at all. This event is for everyone, whether you're a
                  seasoned wine lover or just en joy a glass now and then. It’s
                  all about fun, not formality, and our wine host will guide you
                  through everything in a light, approachable way.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  How many people usually attend?
                </Accordion.Header>
                <Accordion.Body>
                  Most of our wine tasting events host between 30 and 50 people,
                  depending on the v enue. We keep numbers intimate enough for
                  genuine connection but large enough for variety and energy in
                  the room.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>
                  Will I be paired with specific people during the event?
                </Accordion.Header>
                <Accordion.Body>
                  No formal pairings, but the layout of the evening is designed
                  to help you mix and ming le with lots of different people. We
                  rotate seating or tasting groups throughout the night, so
                  you’ll have the chance to chat with several attendees.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header>What should I wear?</Accordion.Header>
                <Accordion.Body>
                  Smart casual is perfect. Think first - date energy , put -
                  together but comfortable. Most v enues are stylish but laid -
                  back, so wear something you feel confident in.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="6">
                <Accordion.Header>Can I come alone?</Accordion.Header>
                <Accordion.Body>
                  Absolutely. Lots of guests come solo, and our hosts make sure
                  you feel welcome from the moment you arrive. It’s a great
                  environment to meet others who are also ther e to connect.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="7">
                <Accordion.Header>Will there be food?</Accordion.Header>
                <Accordion.Body>
                  Yes, most of our wine tastings include small bites or a light
                  food pairing to complement the wines. Check the specific event
                  details when booking to see what’s included.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="8">
                <Accordion.Header>
                  Is there an even male-to-female ratio?
                </Accordion.Header>
                <Accordion.Body>
                  We do our bes t to keep a balanced gender ratio and often
                  manage ticket availability to maintain fairness. This helps
                  create the best experience for everyone attending.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="9">
                <Accordion.Header>
                  Do people actually meet and date from these events?
                </Accordion.Header>
                <Accordion.Body>
                  Yes , and often! We’ve seen everything from first dates to
                  long - term relationships begin over a glass of red or white.
                  The setting makes it easy to chat, laugh, and connect
                  authentically.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="10">
                <Accordion.Header>How do I sign up?</Accordion.Header>
                <Accordion.Body>
                  Just head to yourfriendmyfriend.ie, find the wine tasting
                  event that suits you, and grab your ticket online. You’ll
                  receive a confirmation email with everything you need to know.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="11" className="hololast">
                <Accordion.Header>Are tickets refundable?</Accordion.Header>
                <Accordion.Body>
                  We totally get plans change, or maybe you meet
                  someone...tickets are refundable up to 24 hours prior to the
                  event. That being said, we request that you giv e us as much
                  notice as possible to ensure we have an equal gender balance.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
      <Appqr />
      <Footer />
    </>
  );
};

export default WineTastingPage;
